import userAdmin from './userAdmin';
import forgotPassword from './forgotPassword';
import changePassword from './changePassword';
import changePin from './change-pin';
import reportingInformation from './reportingInformation';
import user from './user/all';

export default function (nameController, nameAction, namePage) {
    userAdmin();
    if ($('[data-view="forgot_password"]').length) forgotPassword();
    if ($('[data-view="change-password"]').length || $('[data-view="reset-password"]').length) changePassword();
    if ($('[data-view="change_pin"]').length) changePin();
    if ($('[data-view="reporting-information"]').length) reportingInformation();
    if(nameController === 'user') user(nameAction, namePage);
}